<template src="./RegisterSpecialty.html"></template>
<script>
import mixins from "../../../../../Mixins.js";
export default {
  mixins: [mixins],
  data() {
    return {
      showContent: false,
      specialties: undefined,
      windowWidth: 0,
      currentx: 1,
      numPages: 0,
      pagination: false,
      searchSpecialties: "",
      popupSpecialty: false,
      popupSpecialtyData: {
        active: undefined,
        hasGender: undefined,
        hasJanssen: undefined,
        id: undefined,
        name: undefined,
      },
      invalidFields: {
        specialtyName: false
      },
      dangerMessageSpecialtyName: "Campo obrigatório",
      toggleActiveId : null
    }
  },
  mounted() {
    const vm = this;
    vm.init();
  },
  created() {
    const vm = this;
    window.addEventListener("resize", vm.handleResize);
    vm.handleResize();
  },
  destroyed() {
    const vm = this;
    window.removeEventListener("resize", vm.handleResize);
  },
  watch: {
    'popupSpecialtyData.name': function(newVal) {
        const vm = this;
        vm.invalidFields.specialtyName = vm.testNullUndefinedEmpty(newVal) && vm.invalidFields.specialtyName;
    },
    currentx: function () {
      const vm = this;
      vm.changePagination();
    },
  },

  methods: {
    init() {
      const vm = this;
      vm.getSpecialties();
    },
    getSpecialties() {
      const vm = this;
      const page = vm.currentx - 1;
      vm.axios
        .get(
          vm.$store.state.filooServer +
          "specialties/findAll?page=" + page + "&search=" + vm.searchSpecialties + "&size=10&sort=id,asc", {
            headers: {
              Authorization: vm.$session.get("bearerDefault")
            },
          }
        )
        .then(function (response) {
          if (response.status == 200) {
            vm.specialties = response.data.content;
            vm.numPages = response.data.totalPages;
            vm.pagination = vm.numPages > 1;
            vm.showContent = true;
          }
        });
    },
    changePagination() {
      const vm = this;
      vm.getSpecialties();
    },
    confirmeChangeStatus(id) {
      const vm = this;
      vm.toggleActiveId = id;
      vm.$bvModal.show("modal-change-status-specialty");
    },
    toggleActive() {
      const vm = this;
      vm.axios
        .put(
          vm.$store.state.filooServer + "specialties/toggle/" + vm.toggleActiveId, {}, {
            headers: {
            Authorization: vm.$session.get("bearerDefault")
            },
          }
        )
        .then(function (response) {
          if (response.status == 200) {
            vm.getSpecialties();
            vm.$bvModal.hide("modal-change-status-specialty");
            vm.showNotifySuccess("Operação realizada","O status da especialidade foi alterado com sucesso", 3000);
          }
        }).catch(function () {
          vm.$bvModal.hide("modal-change-status-specialty");
          vm.showNotifyError("Não foi possível alterar o status da especialidade", 6000);
        })
        .finally(function() {
          vm.$bvModal.hide("modal-change-status-specialty");
        });
    },
    addNewSpecialtyPopup() {
      const vm = this;
      vm.popupSpecialty = true;
      vm.invalidFields.specialtyName = false;
      vm.popupSpecialtyData = {
        active: true,
        hasGender: undefined,
        hasJanssen: undefined,
        id: undefined,
        name: undefined,
      }
    },
    editSpecialtyPopup(specialty) {
      const vm = this;
      vm.popupSpecialty = true;
      vm.popupSpecialtyData = {
        active: specialty.active,
        hasGender: specialty.hasGender,
        hasJanssen: specialty.hasJanssen,
        id: specialty.id,
        name: specialty.name,
      }
    },
    addNewSpecialty() {
      const vm = this;
      vm.invalidFields.specialtyName = vm.testNullUndefinedEmpty(vm.popupSpecialtyData.name);
      if(!vm.invalidFields.specialtyName) {
        vm.axios
        .post(
          vm.$store.state.filooServer + "specialties", vm.popupSpecialtyData, {
            headers: {
              Authorization: vm.$session.get("bearerDefault")
            },
          }
        )
        .then(function (response) {
          if (response.status == 200) {
            vm.popupSpecialty = false;
            vm.$swal({
              title: "Especialidade salva",
              icon: "success",
            });
          }
        });
      }
    },
    editSpecialty() {
      const vm = this;
      vm.invalidFields.specialtyName = vm.testNullUndefinedEmpty(vm.popupSpecialtyData.name);
      if(!vm.invalidFields.specialtyName) {
        vm.axios
        .put(
          vm.$store.state.filooServer + "specialties/" + vm.popupSpecialtyData.id, vm.popupSpecialtyData, {
            headers: {
              Authorization: vm.$session.get("bearerDefault")
            },
          }
        )
        .then(function (response) {
          if (response.status == 200) {
            vm.popupSpecialty = false;
            vm.popupSpecialty = false;
            vm.$swal({
              title: "Especialidade salva",
              icon: "success",
            });
            vm.getSpecialties();
          }
        });
      }
    },
    changeSearchSpecialties() {
      const vm = this;
      vm.currentx = 1;
      vm.getSpecialties();
    },
    handleResize() {
      const vm = this;
      vm.windowWidth = window.innerWidth;
    },
  },
};
</script>
<style lang="scss" src="./RegisterSpecialty.scss">
</style>